import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { eUserRole } from '@Workspace/_generated/enums';
import { AuthService } from '@Workspace/auth';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  private currentUser: any;

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.authService.isLogged) {
        this.router.navigate(['/sign-in']);
        return false;
    } else {
        this.currentUser = this.authService.userSettings;
    }

    if(route.data['accessType'] == 'accounts' || route.data['accessType'] == 'teams'){
        if((!this.currentUser.permissions.isClient && this.currentUser.userRole != eUserRole.LFSocial 
            && this.currentUser.userRole != eUserRole.AdOps 
            && this.currentUser.userRole != eUserRole.LFSocial_Manager 
            && this.currentUser.userRole != eUserRole.AdOps_Manager 
            && this.currentUser.userRole != eUserRole.Trafficker_AdOps 
            && this.currentUser.userRole != eUserRole.Trafficker_Agency))
                return true;
    }

    if(route.data['accessType'] == 'accounts/slug'){
        if(!this.currentUser.permissions.isClient && this.currentUser.userRole != eUserRole.LFSocial 
            && this.currentUser.userRole != eUserRole.AdOps 
            && this.currentUser.userRole != eUserRole.LFSocial_Manager 
            && this.currentUser.userRole != eUserRole.AdOps_Manager 
            && this.currentUser.userRole != eUserRole.Trafficker_AdOps 
            && this.currentUser.userRole != eUserRole.Trafficker_Agency 
            && !this.currentUser.permissions.isLearfieldClient)
                return true;
    }

    if(route.data['accessType'] == 'accounts/users'){
        if((this.currentUser.permissions.isClient && !this.currentUser.permissions.isLearfieldClient 
                && !this.currentUser.permissions.isOASClient && !this.currentUser.permissions.isSocialClient 
                && this.currentUser.userRole != eUserRole.LFSocial 
                && this.currentUser.userRole != eUserRole.AdOps 
                && this.currentUser.userRole != eUserRole.LFSocial_Manager 
                && this.currentUser.userRole != eUserRole.AdOps_Manager) || 
                (!this.currentUser.permissions.isClient && this.currentUser.userRole != eUserRole.LFSocial 
                && this.currentUser.userRole != eUserRole.AdOps 
                && this.currentUser.userRole != eUserRole.LFSocial_Manager 
                && this.currentUser.userRole != eUserRole.AdOps_Manager 
                && this.currentUser.userRole != eUserRole.Trafficker_AdOps 
                && this.currentUser.userRole != eUserRole.Trafficker_Agency))
                    return true;
    }

    if(route.data['accessType'] == 'accounts/users/slug'){
        if(((this.currentUser.permissions.isClient && !this.currentUser.permissions.isLearfieldClient 
                && !this.currentUser.permissions.isOASClient && !this.currentUser.permissions.isSocialClient 
                && this.currentUser.userRole != eUserRole.LFSocial 
                && this.currentUser.userRole != eUserRole.AdOps 
                && this.currentUser.userRole != eUserRole.LFSocial_Manager 
                && this.currentUser.userRole != eUserRole.AdOps_Manager) || 
                (!this.currentUser.permissions.isClient && this.currentUser.userRole != eUserRole.LFSocial 
                && this.currentUser.userRole != eUserRole.AdOps 
                && this.currentUser.userRole != eUserRole.LFSocial_Manager 
                && this.currentUser.userRole != eUserRole.AdOps_Manager 
                && this.currentUser.userRole != eUserRole.Trafficker_AdOps 
                && this.currentUser.userRole != eUserRole.Trafficker_Agency)) && !this.currentUser.permissions.isLearfieldClient)
                    return true;
    }

    if(route.data['accessType'] == 'teams/users'){
        if((!this.currentUser.permissions.isClient 
            && this.currentUser.userRole != eUserRole.LFSocial 
            && this.currentUser.userRole != eUserRole.AdOps
            && this.currentUser.userRole != eUserRole.LFSocial_Manager
            && this.currentUser.userRole != eUserRole.AdOps_Manager)
            || this.currentUser.userRole == eUserRole.Trafficker_AdOps 
            || this.currentUser.userRole == eUserRole.Trafficker_Agency)
                return true;
    }

    if(route.data['accessType'] == 'teams/users/slug'){
        if(!this.currentUser.permissions.isClient 
            && this.currentUser.userRole != eUserRole.LFSocial 
            && this.currentUser.userRole != eUserRole.AdOps
            && this.currentUser.userRole != eUserRole.LFSocial_Manager
            && this.currentUser.userRole != eUserRole.AdOps_Manager
            && this.currentUser.userRole != eUserRole.Trafficker_AdOps 
            && this.currentUser.userRole != eUserRole.Trafficker_Agency)
                return true;
    }

    if(route.data['accessType'] == 'creative-specs' || route.data['accessType'] == 'documents'){
        if(!this.currentUser.permissions.isLearfieldClient && !this.currentUser.permissions.isOASClient 
            && !this.currentUser.permissions.isSocialClient)
            return true;
    }

    if(route.data['accessType'] == 'campaign'){
        const slug = route.paramMap.get('slug');
        if(slug == '00000000-0000-0000-0000-000000000000' && this.currentUser.permissions.isClient && (this.currentUser.permissions.canCreateCampaignEmployee || this.currentUser.permissions.canCreateCampaignClient))
            return true;
        else if(slug != '00000000-0000-0000-0000-000000000000')
            return true;
    }

    if(route.data['accessType'] == 'su-campaign'){
        const slug = route.paramMap.get('slug');
        if(slug == '00000000-0000-0000-0000-000000000000' &&  !this.currentUser.permissions.isClient && (this.currentUser.permissions.canCreateCampaignEmployee || this.currentUser.permissions.canCreateCampaignClient))
            return true;
        else if(slug != '00000000-0000-0000-0000-000000000000')
            return true;
    }

    return false;
  }
}
